import React from "react";
import { SubscriptionType } from "services/api/sessions/sessionService.types";
import {
  FreeUserHeroContainer,
  FreeUserJoinButton,
  FreeUserName,
  FreeUserPackageDetails,
  FreeUserHeroImageWrapper,
  FreeUserHeroImage,
  FreeUserHeroDetailsContainer
} from "./free-user-hero.styles";
import { IFreeUserHeroProps } from "./free-user-hero.types";

const FreeUserHero: React.FC<IFreeUserHeroProps> = ({
  fullName,
  userSubscriptionType,
  activateTrial
}) => {
  return (
    <FreeUserHeroContainer>
      <FreeUserHeroDetailsContainer>
        <FreeUserName>Hai, {fullName}</FreeUserName>
        {userSubscriptionType === SubscriptionType.TRIAL && (
          <>
            <FreeUserPackageDetails>
              Kelas Live gratis aktif selama 6 hari.
            </FreeUserPackageDetails>
            <FreeUserPackageDetails>
              Coba gratis ini cuma ada sekali, loh. Ikut kelasnya, ya!
            </FreeUserPackageDetails>
            <FreeUserJoinButton href="https://colearn.app.link/DownloadCoLearn">
              Ikut kelasnya di aplikasi
            </FreeUserJoinButton>
          </>
        )}
        {userSubscriptionType === SubscriptionType.FREE && (
          <>
            <FreeUserPackageDetails>
              Kamu belum langganan paket belajar.
            </FreeUserPackageDetails>
            <FreeUserPackageDetails>
              Cobain dulu aja Kelas Live gratisnya di aplikasi!
            </FreeUserPackageDetails>
            <FreeUserJoinButton onClick={activateTrial}>
              Coba gratis dulu
            </FreeUserJoinButton>
          </>
        )}
        {userSubscriptionType === SubscriptionType.FREE_AFTER_PAID && (
          <>
            <FreeUserPackageDetails>
              Periode paketmu udah abis.
            </FreeUserPackageDetails>
            <FreeUserPackageDetails>
              Langganan lagi yuk, biar bisa lanjut belajar bareng!
            </FreeUserPackageDetails>
            <FreeUserJoinButton href="/paket">
              Eksplor paket belajar
            </FreeUserJoinButton>
          </>
        )}
        {userSubscriptionType === SubscriptionType.FREE_AFTER_TRIAL && (
          <>
            <FreeUserPackageDetails>
              Coba gratis Kelas Live udah abis.
            </FreeUserPackageDetails>
            <FreeUserPackageDetails>
              Langganan paket yuk, biar bisa lanjut belajar lagi!
            </FreeUserPackageDetails>
            <FreeUserJoinButton href="/paket">
              Eksplor paket belajar
            </FreeUserJoinButton>
          </>
        )}
      </FreeUserHeroDetailsContainer>
      <FreeUserHeroImageWrapper>
        <FreeUserHeroImage
          src="/assets/kelas-live/nara-learning.svg"
          alt="Nara studying with friends"
        />
      </FreeUserHeroImageWrapper>
    </FreeUserHeroContainer>
  );
};

export { FreeUserHero };
